import { render, staticRenderFns } from "./MultipleWeightedText.vue?vue&type=template&id=4c4042c6&scoped=true&"
import script from "./MultipleWeightedText.vue?vue&type=script&lang=js&"
export * from "./MultipleWeightedText.vue?vue&type=script&lang=js&"
import style0 from "./MultipleWeightedText.vue?vue&type=style&index=0&id=4c4042c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../Breeze.Portal.Frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4042c6",
  null
  
)

export default component.exports